module.exports = __webpack_public_path__ + "img/origin_icon.5ae73198.svg";